module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/land-pur-payment/lp-payment-grid/lp-payment-grid.component.css
// module id = ./src/app/landprocurement/land-purchase/land-pur-payment/lp-payment-grid/lp-payment-grid.component.css
// module chunks = main